import React, {useEffect, useState} from 'react';
import { Prompt } from 'react-router-dom';
import { Modal } from 'tea-component';
import { history } from 'umi';
import LeaveModal from '@/pages/datalab/components/LeaveModal';
import {useDblIntl} from "@/pages/datalab/utils/utils";

interface CustomPromptProps {
  className?: string;
  isPrompt: boolean;
  title?: string;
  message: string;
  confirmBtn?: string;
  cancelBtn?: string;
  onCancle?: Function;
  onConfirm?: Function;
  onBeforeunload?: Function;
  caption?: string;
  ignore?: (location: any) => boolean;
}

export function CustomPrompt(props: CustomPromptProps) {
  const [when, setWhen] = useState(false);
  const { title, message, isPrompt,onCancle,onConfirm,onBeforeunload,confirmBtn,cancelBtn, className, caption, ignore } = props;
  
  useEffect(() =>{
    const listener = (event) => {
      event.preventDefault();
      event.returnValue= isPrompt;
      onBeforeunload?.(event,isPrompt);
    };
    isPrompt && window.addEventListener('beforeunload', listener);
    return () => {
      window.removeEventListener('beforeunload', listener);
    };
  }, [isPrompt]);
  
  useEffect(() => {
    setWhen(isPrompt);
  }, [isPrompt]);

  const {commonFormatMessage} = useDblIntl();

  const handlePrompt = (location: any) => {
    // 忽视的路由变更不提示:解决当前页面tab切换时，路由拼接会触发beforeunload，实际并不是离开页面
    if(ignore?.(location)){
      return;
    }
    (document.activeElement as HTMLElement)?.blur();
    setWhen(false);
    const modal = Modal.show({
      disableCloseIcon: false,
      destroyOnClose: true,
      caption,
      onClose() {
        setWhen(isPrompt);
        modal.destroy();
      },
      children: (
        <LeaveModal
          className={className}
          title={title}
          message={message}
          cancle={() => {
            if(onCancle) {
              modal.destroy();
              onCancle(location.pathname);
              return;
            }
            setWhen(isPrompt);
            modal.destroy();
          }}
          confirm={() => {
            if(onConfirm) {
              onConfirm(location);
              modal.destroy();
              return;
            }
            modal.destroy();
            history.push(location.pathname + location.search);
          }}
          confirmBtn={confirmBtn}
          cancelBtn={cancelBtn}
          dblCommonFormatMessage={commonFormatMessage}
        />
      ),
    });
    return false;
  };

  return <Prompt when={when} message={handlePrompt} />;
}
